import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../shared/services/api.service';

export interface TypeOfMembership {
  tomCode: number;
  tomCodeAlpha: string;
  tomCodeDesc: string;
}

@Injectable({
  providedIn: 'root'
})
export class ReferenceService {
  private apiService = inject(ApiService);

  getTypesOfMembership(): Observable<TypeOfMembership[]> {
    return this.apiService.get<TypeOfMembership[]>('/api/reference/tom');
  }
}
